export const TERMS_URL =
  'https://assets-global.website-files.com/650b431b9bd9e4f93c4019b4/65dcbf3767ae3dfab859c8a9_Higo%20-%20Te%CC%81rminos%20y%20condiciones%20act.pdf';
export const PRIVACY_POLICY_URL =
  'https://assets-global.website-files.com/650b431b9bd9e4f93c4019b4/65dcbf49b3903bbbb51b56a7_Aviso%20de%20Privacidad%20Higo.pdf';
